export default {"src":"/_next/static/media/logo.093a9ef5.svg","height":40,"width":43,"blurWidth":0,"blurHeight":0};